import { render } from "./message-comment.vue?vue&type=template&id=3c8ef8de"
import script from "./message-comment.vue?vue&type=script&lang=js"
export * from "./message-comment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__